


























































import { Component, Vue, Prop } from 'vue-property-decorator';
import searchForm from './searchForm.json';
import { typeLists } from './Service/Lists';

@Component
export default class componentName extends Vue {
  private searchForm: {} = searchForm;

  private form: typeLists.request = {};

  private advSearch() {
    this.form.page = 1;
    const query: any = { ...this.$route.query, ...this.form };
    delete query.search_complex;
    this.$emit('close');
    this.$router.push({ query });
  }

  private resetForm(formName: string) {
    this.form = {};
    const { path } = this.$route;
    this.$emit('close');
    this.$router.push(path);
  }

  private mounted() {
    const { query } = this.$route;
    const querySetting = JSON.parse(JSON.stringify(query));
    this.form = querySetting;
  }
}
